import { render, staticRenderFns } from "./UsersForDelete.vue?vue&type=template&id=c5791e98"
import script from "./UsersForDelete.vue?vue&type=script&lang=js"
export * from "./UsersForDelete.vue?vue&type=script&lang=js"
import style0 from "./UsersForDelete.vue?vue&type=style&index=0&id=c5791e98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports